import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/api/queryKeys";
import { toast } from "@/lib/toast";
import { deleteByokKey } from "../api";

export function useDeleteByokKey() {
  const qc = useQueryClient();
  return useMutation<{ id: string; deleted: true }, unknown, string>({
    mutationFn: deleteByokKey,
    onSuccess: () => {
      toast.success("Chave removida");
      qc.invalidateQueries({ queryKey: queryKeys.byok.all });
    },
    onError: () => toast.error("Falha ao remover"),
  });
}
